import { render, staticRenderFns } from "./UpdateempRight.vue?vue&type=template&id=4f6eb926&scoped=true"
import script from "./UpdateempRight.vue?vue&type=script&lang=js"
export * from "./UpdateempRight.vue?vue&type=script&lang=js"
import style0 from "./UpdateempRight.vue?vue&type=style&index=0&id=4f6eb926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6eb926",
  null
  
)

export default component.exports